export function openClose() {
    var itemButton = $(".open-close-link");

    itemButton.on("click", function (e) {
        var elem = $(this);
        var elemContainer = elem.closest(".content");
        elemContainer.toggleClass("show");

        return false;
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/openClose.js